import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PrepareOrderForm } from './PrepareOrderForm';
import { ServeOrderForm } from './ServeOrderForm';

export function PrepareOrderMobilePage({ orderId }) {
  const [showServeDialog, setShowServeDialog] = useState(false);

  const handleClose = () => {
    window.location.hash = '#/pedidos';
  };

  const handleServe = () => {
    setShowServeDialog(true);
  };

  return (
    <div className="min-h-[100dvh] bg-white">
      <PrepareOrderForm
        orderId={orderId}
        onClose={handleClose}
        onServe={handleServe}
        mobilePicking
        showMobileQr={false}
      />

      <Dialog open={showServeDialog} onOpenChange={setShowServeDialog}>
        <DialogContent className="h-[96dvh] max-h-[96dvh] w-[96vw] max-w-[96vw] overflow-auto p-3">
          <DialogHeader>
            <DialogTitle>Servir Pedido</DialogTitle>
          </DialogHeader>
          <ServeOrderForm
            orderId={orderId}
            onClose={() => setShowServeDialog(false)}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
